export default "__VITE_ASSET__C9JZmQ86__"